import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Paper,
  Typography,
  Box,
  Checkbox,
} from "@mui/material";
import FilaExpandible from "./FilaExpandible";
import {
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
} from "@mui/icons-material";
import { getData } from "../../../../../services/library"

const TablaConciliacion = ({
  datosPaginados,
  datosActuales,
  page,
  rowsPerPage,
  selectedTab,
  emptyRows,
  expandedRows,
  toggleExpandRow,
  handleChangePage,
  handleChangeRowsPerPage,
  ordenColumna,
  ordenDireccion,
  onOrdenar,
  selectedItems,
  onSelectItem,
  onSelectAll,
  showCheckbox,
  empresa,
  onDesconciliar,
  observaciones,
  onObservacionGuardada
}) => {
  const totalColumns = showCheckbox ? 7 : 6;
  const [sucursalesML, setSucursalesML] = useState([])
  const obtenerSucursalesML = () =>{
    getData("/envasado_sucursales_mercadolibre/xempresa/"+empresa, setSucursalesML)
  }
  useEffect(() => {
    obtenerSucursalesML()
  }, [empresa])  

  const getSelectableItems = () => {
    return datosPaginados.filter((item, index) => {
      const dbData = item.db || item;
      return dbData?.conciliado !== 1;
    });
  };

  const selectableItems = getSelectableItems();
  const allSelected =
    selectableItems.length > 0 &&
    selectableItems.every((item, index) => {
      const globalIndex = page * rowsPerPage + index;
      const key = `${selectedTab}-${globalIndex}`;
      return selectedItems[key] || false;
    });



  return (
    <TableContainer
      component={Paper}
      variant="outlined"
      sx={{ borderColor: "#e8e8e8" }}
    >
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: "#fafafa" }}>
            {showCheckbox && (
              <TableCell sx={{ width: 40, p: 1 }}>
                <Checkbox
                  size="small"
                  checked={allSelected}
                  onChange={(e) => onSelectAll(e.target.checked)}
                  disabled={selectableItems.length === 0}
                />
              </TableCell>
            )}
            <TableCell
              sx={{
                fontWeight: 500,
                color: "#424242",
                fontSize: "0.75rem",
                cursor: "pointer",
                "&:hover": { backgroundColor: "#f0f0f0" },
              }}
              onClick={() => onOrdenar("referencia")}
            >
              <Box display="flex" alignItems="center" gap={0.5}>
                Referencia
                {ordenColumna === "referencia" &&
                  (ordenDireccion === "asc" ? (
                    <ArrowUpwardIcon sx={{ fontSize: 14 }} />
                  ) : (
                    <ArrowDownwardIcon sx={{ fontSize: 14 }} />
                  ))}
              </Box>
            </TableCell>
            <TableCell
              sx={{
                fontWeight: 500,
                color: "#424242",
                fontSize: "0.75rem",
                cursor: "pointer",
                "&:hover": { backgroundColor: "#f0f0f0" },
              }}
              onClick={() => onOrdenar("fecha")}
            >
              <Box display="flex" alignItems="center" gap={0.5}>
                Fecha
                {ordenColumna === "fecha" &&
                  (ordenDireccion === "asc" ? (
                    <ArrowUpwardIcon sx={{ fontSize: 14 }} />
                  ) : (
                    <ArrowDownwardIcon sx={{ fontSize: 14 }} />
                  ))}
              </Box>
            </TableCell>
            <TableCell
              align="right"
              sx={{
                fontWeight: 500,
                color: "#424242",
                fontSize: "0.75rem",
                cursor: "pointer",
                "&:hover": { backgroundColor: "#f0f0f0" },
              }}
              onClick={() => onOrdenar("montoDB")}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-end"
                gap={0.5}
              >
                Monto Sistema
                {ordenColumna === "montoDB" &&
                  (ordenDireccion === "asc" ? (
                    <ArrowUpwardIcon sx={{ fontSize: 14 }} />
                  ) : (
                    <ArrowDownwardIcon sx={{ fontSize: 14 }} />
                  ))}
              </Box>
            </TableCell>
            <TableCell
              align="right"
              sx={{
                fontWeight: 500,
                color: "#424242",
                fontSize: "0.75rem",
                cursor: "pointer",
                "&:hover": { backgroundColor: "#f0f0f0" },
              }}
              onClick={() => onOrdenar("montoMP")}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-end"
                gap={0.5}
              >
                Bruto MP
                {ordenColumna === "montoMP" &&
                  (ordenDireccion === "asc" ? (
                    <ArrowUpwardIcon sx={{ fontSize: 14 }} />
                  ) : (
                    <ArrowDownwardIcon sx={{ fontSize: 14 }} />
                  ))}
              </Box>
            </TableCell>
            <TableCell
              align="right"
              sx={{
                fontWeight: 500,
                color: "#424242",
                fontSize: "0.75rem",
                cursor: "pointer",
                "&:hover": { backgroundColor: "#f0f0f0" },
              }}
              onClick={() => onOrdenar("montoNeto")}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-end"
                gap={0.5}
              >
                Neto MP
                {ordenColumna === "montoNeto" &&
                  (ordenDireccion === "asc" ? (
                    <ArrowUpwardIcon sx={{ fontSize: 14 }} />
                  ) : (
                    <ArrowDownwardIcon sx={{ fontSize: 14 }} />
                  ))}
              </Box>
            </TableCell>
            <TableCell
              align="center"
              sx={{ fontWeight: 500, color: "#424242", fontSize: "0.75rem" }}
            >
              Acciones
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {datosPaginados.length === 0 ? (
            <TableRow>
              <TableCell colSpan={totalColumns} align="center">
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ py: 3 }}
                >
                  No hay registros para mostrar
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            datosPaginados.map((item, index) => {
              const globalIndex = page * rowsPerPage + index;
              const key = `${selectedTab}-${globalIndex}`;
              const isCoincidencia = selectedTab === 0;
              const isSoloDB = selectedTab === 1;
              const isSoloMP = selectedTab === 2;
              const dbData = item.db || item;
              const isConciliado = dbData?.conciliado === 1;
              return (
                <FilaExpandible
                  key={key}
                  item={item}
                  isCoincidencia={isCoincidencia}
                  isSoloDB={isSoloDB}
                  isSoloMP={isSoloMP}
                  expanded={expandedRows[key] || false}
                  onToggle={() => toggleExpandRow(key)}
                  showCheckbox={showCheckbox}
                  isSelected={selectedItems[key] || false}
                  onSelect={(checked) => onSelectItem(key, checked)}
                  isDisabled={isConciliado}
                  sucursalesML={sucursalesML}
                  onDesconciliar={onDesconciliar}
                  empresa={empresa}
                  observaciones={observaciones}
                  onObservacionGuardada={onObservacionGuardada}
                />
              );
            })
          )}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={totalColumns} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={totalColumns}
              count={datosActuales.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              labelRowsPerPage="Filas por página:"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} de ${count}`
              }
              sx={{
                ".MuiTablePagination-select": { fontSize: "0.8rem" },
                ".MuiTablePagination-displayedRows": { fontSize: "0.8rem" },
              }}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default TablaConciliacion;
